import { ControlCategories, PartnerEvents } from "@theprelude/core";
import { MissingControlCategoryCard } from "./missing-control-category-card";

export const MissingEDRCard = () => (
  <MissingControlCategoryCard
    category={ControlCategories.XDR}
    partnerEvent={PartnerEvents.NO_EDR}
    description="Devices in a broken state."
  />
);
